<template>

 <v-dialog max-width="600px" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
        class="indigo accent-1"
        light small mt-4 absolute middle right ><v-icon>edit</v-icon></v-btn>

    <v-card>
      <v-card-title>
        <h2>Either edit unit name or merge into another unit</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
             <v-layout row>
              <v-flex xs12>
                <v-text-field  v-if="showDialog" autofocus v-model="edittedUnit.name" name='unitName' label="Unit Name"
                  :rules="[rules.required, rules.min]" />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs4>
                <div class="text-xs-left">
                <v-btn  flat outline color="black" @click='showMerge'>
                  <v-icon small left>arrow_right_alt</v-icon>
                 <span>Merge into another Unit</span>
                </v-btn>               
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if='showingMerge'>
              <v-flex xs12 my-3 py-3>
                <div style="margin-top:-30px;border:1px solid white">
                  <div class="grey--text" style='text-align:left'>All the people assigned to the current unit "{{edittedUnit.name}}"" 
                        will be moved to the new unit you choose, and the current unit will cease to exist.                         
                  </div> 
                  <multiselect v-model="mergeToUnit" id="ajaxms" label="name" track-by="id"
                          placeholder="Select the unit to merge into - type at least 3 characters to search" open-direction="bottom" :options="toUnits" :multiple="false" :searchable="true"
                          :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true" 
                          :options-limit="1000" :limit="1" :limit-text="limitText" :max-height="300"
                          :show-no-results="true" :hide-selected="false" @search-change="loadUnits">
                          <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                              <span>{{ option.name }}</span>
                              <span class="custom__remove" @click="remove(option)">❌</span>
                            </span>
                          </template>
                          <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="mergeToUnit" @mousedown.prevent.stop="clearAll(props.search)"></div>
                          </template>
                          <span slot="noResult">Oops! No units found. Consider changing the search query.</span>
                    </multiselect>
                  </div>
                  <v-btn flat outline color="black" @click='hideMerge'>
                        <v-icon small left>cancel</v-icon>
                        <span>Cancel merge</span>
                  </v-btn> 
              </v-flex>
            </v-layout>
 
           <provenance-and-note v-bind:record="edittedUnit"/>

          <v-layout row>
             <v-flex xs12>
                <div class="danger-alert" v-html="error"></div>
              </v-flex>
            </v-layout>

            <v-layout row>          
              <v-flex xs4>
              </v-flex>
              <v-flex xs4>
                <v-btn dark class="indigo darken-1" @click='editUnit' :loading="loading"><v-icon left >save_alt</v-icon>{{editButtonPrompt}}</v-btn>
              </v-flex>
              <v-flex xs4>
              </v-flex>
            </v-layout>

        </v-form>
      </v-card-text>
    </v-card>
 </v-dialog>    
</template>        

<script>

import Panel from '@/components/Panel' ;
import UnitService from "@/services/UnitService" ;

export default {
  components: { Panel },     

  data () {
    return {
      unit: {},
      edittedUnit: {  
        id: parseInt(this.$route.params.id),
        name: '',
        provenance: '',
        note: '',
        mergedToUnitId: -1
      },
      error: null,
      message: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Minimum of 8 characters is required.'
      },
      mergeToUnit: null,
      toUnits: [],
      isLoading: false,
      showingMerge: false,
      editButtonPrompt: "Edit Unit Name",
      loading: false,
      showDialog: false 
    }
  },

  async mounted () {
    console.log("in unitedit mounted") ;
    await this.readData() ;
  },

  methods: {
    async editUnit () {
      console.log("IN editUnit") ; 
      this.error = null ;
      if (this.showingMerge) {
        if (!this.mergeToUnit) {
          this.error = "Select a unit to merge this unit into" ;
          return ;
        }
        console.log("mergeToUnit=" + JSON.stringify(this.mergeToUnit)) ;
        try {
          console.log("at 1") ;
          this.loading = true ;
          this.edittedUnit.mergedToUnitId = this.mergeToUnit.id ;
          const response = await UnitService.mergeTo(this.edittedUnit) ;
          console.log("at 2") ;
          console.log("mergeTo response: " + JSON.stringify(response)) ;

          // this.message = response.data.message
          console.log("success mergeTo, resp data=" + JSON.stringify(response.data)) ;
          this.showDialog = false ;
          this.$store.dispatch('setPendingMessage', {text: "Unit " + this.edittedUnit.name + " merged and deleted", color: 'success'}) 
          this.$router.push('/unit/' + response.data.id) ;
        }
        catch (err) {
          console.log("catch err:" + JSON.stringify(err)) ;
          // console.log("ee=" + err.response.data.error)

          this.error = err.response.data.error  ;
        }
        finally {
          this.loading = false ;
        }
        return ;
      }

      try {
        this.loading = true ;
        const response = await UnitService.edit(this.edittedUnit) ;
        console.log("editUnit response: " + JSON.stringify(response)) ;

        // this.message = response.data.message
        console.log("success edit, resp data=" + JSON.stringify(response.data)) ;
        this.showDialog = false ;        
        this.$renderToastInParent(this, "Unit name successfully changed") ;
        // this.$router.push('/unit/' + response.data.id) ;
      }
      catch (err) {
        console.log("catch err:" + JSON.stringify(err)) ;
        // console.log("ee=" + err.response.data.error)

        this.error = err.response.data.error  ;
      }
      finally {
        this.loading = false ;
      }      
    },

    async readData () {
      const result = await UnitService.id(this.edittedUnit.id) ;
      this.unit = result.data ;
      // console.log("Back from us, this.unit=" + JSON.stringify(result)) ;
      this.edittedUnit.name = this.unit.v ;
    },

    async loadUnits (query) {
      if (query.length < 2) return ;
      this.isLoading = true ;
      const result = await UnitService.index(query, 0, 1000) ;
      const d = result.data ;
      const possibleMergeUnits = [] ;
      for (let i = 0 ; i < d.length ; i++) {
        const du = d[i] ;
        if (du.id === this.edittedUnit.id) continue ;  // never include ourself
        du.name += " - " + du.count + ((du.count === 1) ? " person" : " people") ;
        possibleMergeUnits.push(du) 
      }
      this.toUnits = possibleMergeUnits ;
      this.isLoading = false ;
    },

    limitText (count) {
      return `and ${count} other units`
    },

    clearAll () {
      this.mergeToUnit = null ;
    },

    showMerge () {
      console.log("showMerge clicked") ;
      this.showingMerge = true ;
      this.editButtonPrompt = "Merge (and then delete) Unit" ;
    },
    hideMerge () {
      this.showingMerge = false ;
      this.editButtonPrompt = "Edit Unit Name" ;
      this.mergeToUnit = null ;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UnitEdit.vue